import enviro from 'enviro';

// Tab-filter path segments from pricing-pages-ui/v2/constants/Tabs.
// These are URL slugs — stable by contract; not imported to avoid a
// pricing-pages-ui dependency.
const STARTER = 'starter';
const ENTERPRISE = 'enterprise';
export function getBooleanFromString(value) {
  return value === 'true';
}
export function getQueryParam(name) {
  try {
    return new URLSearchParams(window.location.search).get(name);
  } catch (_unused) {
    return null;
  }
}

/*
 * Constructs an in-app short-link redirect URL from a public hubspot.com/pricing URL.
 * Mirrors pricing-pages-ui/earlyRequester/earlyRequesterUtils.getShortLinkForRedirect
 * so public-app has no dependency on pricing-pages-ui for this setup utility.
 */
export function getShortLinkForRedirect(url) {
  const {
    hostname,
    pathname,
    search
  } = new URL(url);
  const isQA = hostname.includes('hubspotqa') || hostname.includes('wthubspot');
  const appDomain = enviro.ifHublet({
    isNa1() {
      return `app.hubspot${isQA ? 'qa' : ''}.com`;
    },
    isNonNa1(hublet) {
      return `app-${hublet}.hubspot${isQA ? 'qa' : ''}.com`;
    }
  });

  // Strip tier-tab path segments that the in-app page doesn't use.
  const newPath = pathname.split('/').slice(2).filter(path => path !== STARTER && path !== ENTERPRISE).join('/');
  if (!search.includes('upgradeSource')) {
    const newSearch = new URLSearchParams(search);
    newSearch.set('upgradeSource', 'public-pricing-redirect');
    const qs = newSearch.toString();
    return `https://${appDomain}/l/pricing/${newPath}${qs ? `?${qs}` : ''}`;
  }
  return `https://${appDomain}/l/pricing/${newPath}${search}`;
}